import moment from 'moment';

const yup = require('yup');

// eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
const nonNumericalRegex = new RegExp('^([^0-9]*)$');

const passwordRegex = new RegExp(
    '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[<=>:+()€±;|`/ ._§£"#?!°@$%^&*{}\'\\[\\],-]).{8,}$',
);

const email = yup.string().min(5, 'MIN_LENGTH').max(130, 'MAX_LENGTH').email('INVALID');

const emailOsflm = yup.string().max(130, 'MAX_LENGTH').email('INVALID').matches(new RegExp('^[^+]+$'), 'INVALID');

const password = yup
    .string()
    .min(8, 'INVALID')
    .max(60, 'INVALID')
    .matches(passwordRegex, 'INVALID')
    .required('REQUIRED');

const passwordSigIn = yup.string().required('REQUIRED');

const passwordConfirmation = yup
    .string()
    .oneOf([yup.ref('password')], 'DOES_NOT_MATCH')
    .required('REQUIRED');

const message = yup.string().min(2, 'MIN_LENGTH').max(320, 'MAX_LENGTH');

const codeTfa = yup.string().min(2, 'MIN_LENGTH').max(6, 'MAX_LENGTH');

const contactMessage = yup.string().min(30, 'MIN_LENGTH').max(1500, 'MAX_LENGTH');

const optInRequired = yup.bool().oneOf([true], 'MUST_BE_CHECKED').required('REQUIRED');

const confirmCGU = yup.bool().oneOf([true], 'MUST_BE_CHECKED').required('REQUIRED');
const confirmAge18 = yup.bool().oneOf([true], 'MUST_BE_CHECKED').required('REQUIRED');

const firstCondition = yup.bool().oneOf([true], 'MUST_BE_CHECKED').required('REQUIRED');
const secondCondition = yup.bool().oneOf([true], 'MUST_BE_CHECKED').required('REQUIRED');
const thirdCondition = yup.bool().oneOf([true], 'MUST_BE_CHECKED').required('REQUIRED');

const name = yup
    .string()
    .matches(/^[A-Za-zàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšž '-]+$/, 'CARACTERS_NOT_SUPPORTED')
    .min(2, 'MIN_LENGTH')
    .max(60, 'MAX_LENGTH')
    .matches(nonNumericalRegex, 'NON_NUMERICAL');

const title = yup
    .string()
    .matches(
        /^((?!\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]).)*$/,
        'EMOTES_NOT_SUPPORTED',
    )
    .min(2, 'MIN_LENGTH')
    .max(60, 'MAX_LENGTH');

// eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
const birthday = yup
    .string()
    .typeError('INVALID_DATE')
    .test('birthday', 'MIN_AGE', (value) => {
        return moment().diff(moment(value), 'years') >= 18;
    });

export const phoneRegex = new RegExp(
    '^(?:(?:\\+|00)33[\\s.-]{0,3}(?:\\(0\\)[\\s.-]{0,3})?|0)[1-9](?:(?:[\\s.-]?\\d{2}){4}|\\d{2}(?:[\\s.-]?\\d{3}){2})$',
);

const phone = yup
    .string()
    .trim()
    .test('phone-regex', 'INVALID', (val) => !val || phoneRegex.test(val));

const address = yup.string().min(2, 'MIN_LENGTH').max(60, 'MAX_LENGTH');

export const passwordForgottenSubmitNewPassword = yup.object({
    password,
    passwordConfirmation,
});

export const signIn = yup.object({
    email: email.required('REQUIRED'),
    password: passwordSigIn,
});

export const passwordForgottenLinkGeneration = yup.object({
    email: email.required('REQUIRED'),
});

export const confirmModificationSchema = yup.object({
    message: message.required('REQUIRED'),
    email: email,
});

export const codeValidationSchema = yup.object({
    code: message.required('REQUIRED'),
    email: email,
});

export const smsValidationSchema = yup.object({
    telephone: phone.required('REQUIRED'),
});

export const tfaValidationSchema = yup.object({
    code: codeTfa.required('REQUIRED'),
});

export const signUpStepOneSchema = (fieldsNotRequired: boolean) =>
    yup.object({
        email: email.required('REQUIRED'),
        password: fieldsNotRequired ? null : password,
        confirmPassword: fieldsNotRequired ? null : passwordConfirmation,
    });

export const signUpStepTwoSchema = (fieldsRequired: boolean) =>
    yup.object({
        firstName: name.required('REQUIRED'),
        lastName: name.required('REQUIRED'),
        birthdayPE: birthday.required('REQUIRED'),
        optInRequired,
        password: fieldsRequired ? password : null,
        confirmPassword: fieldsRequired ? passwordConfirmation : null,
    });

export const offerPotStepOneSchema = yup.object({
    firstName: name.required('REQUIRED'),
    lastName: name.required('REQUIRED'),
    email: email.required('REQUIRED'),
});

export const offerPotStepTwoSchema = yup.object({
    title: title.required('REQUIRED'),
});

export const confirmPasswordSchema = yup.object({
    password: yup.string().required('REQUIRED'),
});

export const contactSchema = yup.object({
    firstName: name.required('REQUIRED'),
    lastName: name.required('REQUIRED'),
    email: email.required('REQUIRED'),
    message: contactMessage.required('REQUIRED'),
    telephone: phone,
});

export const helpCenterContactSchema = yup.object({
    firstName: name.required('REQUIRED'),
    lastName: name.required('REQUIRED'),
    email: email.required('REQUIRED'),
    contactMessage: contactMessage.required('REQUIRED'),
    phoneNumber: phone,
});

export const osflmSchema = yup.object({
    firstName: name.required('REQUIRED'),
    email: emailOsflm.required('REQUIRED'),
    telephone: phone.required('REQUIRED'),
    confirmCGU,
    confirmAge18,
});

export const updateUserInfoSchema = yup.object({
    firstName: name.required('REQUIRED'),
    lastName: name.required('REQUIRED'),
});

export const updateEmailSchema = yup.object({
    newEmail: email.required('REQUIRED'),
    emailConfirmation: yup
        .string()
        .oneOf([yup.ref('newEmail')], 'DOES_NOT_MATCH')
        .required('REQUIRED'),
});

export const compitionsGameValidationSchema = (
    addressRequired,
    phoneRequired,
    condition1Required,
    condition2Required,
    condition3Required,
) =>
    yup.object({
        firstName: name.required('REQUIRED'),
        lastName: name.required('REQUIRED'),
        email: email.required('REQUIRED'),
        phoneNumber: phoneRequired ? phone.required('REQUIRED') : phone,
        postalAddress: addressRequired ? address.required('REQUIRED') : address,
        first_condition: condition1Required ? firstCondition : null,
        second_condition: condition2Required ? secondCondition : null,
        third_condition: condition3Required ? thirdCondition : null,
    });

export const newsLetterSchema = yup.object({
    email: email.required('REQUIRED'),
});

export const ppeUserInfoValidationSchema = yup.object({
    firstName: yup.string().required('REQUIRED'),
    lastName: yup.string().required('REQUIRED'),
    birthday: birthday.required('REQUIRED'),
    birthPlace: address.required('REQUIRED'),
    address: address.required('REQUIRED'),
    countryOfResidence: address.required('REQUIRED'),
    phoneNumber: yup.string().required('REQUIRED'),
    email: email.required('REQUIRED'),
    optInRequired,
});
